<template>
    <div class="read-more" :class="{...wrapperClass}">
        <div class="read-more__content" v-html="content" :style="contentStyle" />
        <button v-if="isNeeded" class="read-more__button" @click="handleToggle">
            {{ isOpen ? "Read less" : "Read More" }}
        </button>
    </div>
</template>
<script>
    export default {
        name: "ReadMore",
        props: {
            content: {
                type: String,
                required: true,
            },
            wrapperClass: {
                type: Object,
                default : () => ({})
            }
        },
        data: () => ({
            isOpen: false,
        }),
        computed: {
            isNeeded() {
                return this.content.length > 540;
            },
            contentStyle() {
                return {
                    height: this.isOpen || !this.isNeeded ? 'auto' : '96px',
                    overflow: 'hidden'
                }
            }
        },
        methods: {
            handleToggle() {
                this.isOpen = !this.isOpen;
            }
        }
    }
</script>
<style lang="scss">
@import '~@/theme/_variables.scss';
.read-more {
    .read-more__content {
        color: $text;
        display: flex;
        flex-direction: column;

        p {
            margin: 0;
            font-size: 1.4rem;
        }
    }

    .read-more__button {
        appearance: none;
        -webkit-appearance: none;
        background-color: transparent;
        border: none;
        margin-top: .5rem;
        font-weight: 600;
        padding: 0;
        font-family: "Axiforma", sans-serif;
        font-size: 1.3rem;
        color: $link;
    }
}
</style>
